import { OBJLoader } from 'three/addons/loaders/OBJLoader.js';

export function loadModelFromPath(texturePainter, path) {
    return new Promise((resolve, reject) => {
        const loader = new OBJLoader();
        loader.load(
            path,
            (object) => {
                if (texturePainter.mesh) {
                    texturePainter.scene.remove(texturePainter.mesh);
                }
                texturePainter.mesh = object;
                texturePainter.scene.add(texturePainter.mesh);
                texturePainter.analyzeUVChannels();
                texturePainter.centerModel();
                document.getElementById('loadingScreen').classList.add('hidden');
                resolve(object);
            },
            (progress) => {
                const percent = (progress.loaded / progress.total * 100).toFixed(2);
                console.log(`Loading model: ${percent}%`);
            },
            (error) => {
                console.error('Error loading model:', error);
                document.getElementById('loadingScreen').classList.add('hidden');
                reject(error);
            }
        );
    });
}
